export default "__VITE_ASSET__DDVKbmiS__"